export default __webpack_public_path__ + "img/young-scout.63615896.svg";